<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <router-view/>
    </div>
  </a-config-provider>
</template>
<script>
  import { mapGetters } from 'vuex'
  import enUs from 'ant-design-vue/lib/locale-provider/en_US'
  import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
  import uzUZ from 'ant-design-vue/lib/locale-provider/uz_UZ'
  import moment from 'moment';
  import 'moment/locale/uz-latn';

  export default {
    data () {
      return {
        locale: uzUZ,
      }
    },
    computed: {
      ...mapGetters(["language"]),
    },
    methods: {
        
    },
    watch: {
      language:{
        handler (newVal, oldVal) {
            console.log('language changed from', oldVal, 'to', newVal);
            switch(newVal){
              case 'uz':
                  this.locale = uzUZ
                  moment.locale('uz-latn');
                  break;
                case 'en':
                  this.locale = enUs
                  break;
                case 'zh':
                  this.locale = zhCN
                  break;
                default:
                  this.locale = uzUZ
                  break;
            }
            this.$i18n.locale = newVal;
            
          },
          immediate: true
      }
    },
    created () {
      
    }
  }
</script>
<style>
  #app {
    height: 100%;
  }
</style>